import { __read } from 'tslib';
import { useState, useCallback } from 'react';

var useBoolean = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.defaultValue, defaultValue = _c === void 0 ? false : _c;
    var _d = __read(useState(defaultValue), 2), value = _d[0], setValue = _d[1];
    var toggleValue = useCallback(function () { return setValue(function (current) { return !current; }); }, [setValue]);
    return [value, setValue, toggleValue];
};

export { useBoolean };
//# sourceMappingURL=index.js.map
